import { Typography, Box, Grid, Stack } from "@mui/material";

export default function BinCardSettings({ rawData }) {
  if (!rawData) {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty JSON data
      </Typography>
    );
  }
  return (
    <Stack spacing={1} sx={{ p: 2, pt: 1, flex: 1, justifyContent: 'center' }}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 1,
            py: 3,
            backgroundColor: '#E1BEE7',
            borderRadius: 1,
            border: '1px solid',
            borderColor: '#9C27B0',
          }}>
            <Typography variant="body2" sx={{
              color: '#6A1B9A',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              All Star
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: '#6A1B9A',
              fontSize: '0.8rem',
            }}>
              {rawData ? `${String(rawData.allstar)} coins` : "N/A"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 1,
            py: 3,
            backgroundColor: '#FFD700',
            borderRadius: 1,
            border: '1px solid',
            borderColor: '#DAA520',
          }}>
            <Typography variant="body2" sx={{
              color: '#B8860B',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Gold
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: '#B8860B',
              fontSize: '0.8rem',
            }}>
              {rawData ? `${String(rawData.gold)} coins` : "N/A"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 1,
            py: 3,
            backgroundColor: '#C0C0C0',
            borderRadius: 1,
            border: '1px solid',
            borderColor: '#A9A9A9',
          }}>
            <Typography variant="body2" sx={{
              color: '#696969',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Silver
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: '#696969',
              fontSize: '0.8rem',
            }}>
              {rawData ? `${String(rawData.silver)} coins` : "N/A"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 1,
            py: 3,
            backgroundColor: 'primary.light',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'primary.main',
          }}>
            <Typography variant="body2" sx={{
              color: 'primary.dark',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Base
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: 'primary.dark',
              fontSize: '0.8rem',
            }}>
              {rawData ? `${String(rawData.base)} coins` : "N/A"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  )
}
